import(/* webpackMode: "eager" */ "/app/app/[locale]/about/page.tsx");
